import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const DeleteIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M10.8067 2C10.2897 2 9.79577 2.20431 9.42977 2.57031L9.00008 3H4.00008C3.86757 2.99813 3.73601 3.02261 3.61304 3.07202C3.49007 3.12143 3.37815 3.1948 3.28378 3.28784C3.18941 3.38088 3.11447 3.49176 3.06333 3.61401C3.01218 3.73627 2.98584 3.86747 2.98584 4C2.98584 4.13253 3.01218 4.26373 3.06333 4.38599C3.11447 4.50824 3.18941 4.61912 3.28378 4.71216C3.37815 4.8052 3.49007 4.87857 3.61304 4.92798C3.73601 4.97739 3.86757 5.00187 4.00008 5H20.0001C20.1326 5.00187 20.2642 4.97739 20.3871 4.92798C20.5101 4.87857 20.622 4.8052 20.7164 4.71216C20.8108 4.61912 20.8857 4.50824 20.9368 4.38599C20.988 4.26373 21.0143 4.13253 21.0143 4C21.0143 3.86747 20.988 3.73627 20.9368 3.61401C20.8857 3.49176 20.8108 3.38088 20.7164 3.28784C20.622 3.1948 20.5101 3.12143 20.3871 3.07202C20.2642 3.02261 20.1326 2.99813 20.0001 3H15.0001L14.5704 2.57031C14.2054 2.20431 13.7104 2 13.1934 2H10.8067ZM4.36532 7L5.89266 20.2637C6.02466 21.2537 6.87708 22 7.87508 22H16.1231C17.1211 22 17.9745 21.2549 18.1075 20.2559L19.6348 7H4.36532Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

DeleteIcon.propTypes = {
  sx: PropTypes.object,
};

export default DeleteIcon;
